import React from "react"
import SeatStyle from "./seat.module.scss"

class Seat extends React.Component {

  setSeat = (seat) => {
    this.props.setSeat(seat)
  }

  componentDidUpdate(prevProps) {
    //this.render(this.prop);
  } 

  render() {
    let { enabled, seat, available, currentSeats } = this.props;
    const isAvailable = available
    const isCurrent = currentSeats.indexOf(seat) >= 0
    const availableButtonClasses = 
      enabled ? 
        isCurrent ? `selectable ${SeatStyle.button} ${SeatStyle.current}` : `selectable ${SeatStyle.button}` :
        `${SeatStyle.button} ${SeatStyle.button_unavailable}`

    return (
      <div key={seat}>
        { isAvailable ? (
          <button onClick={() => this.setSeat(seat)} className={availableButtonClasses} />
        ) : (
          <div title={`Il posto ${seat} non è disponibile`} className={`${SeatStyle.button} ${enabled ? SeatStyle.button_unavailable : SeatStyle.button_booked}`}/>
        )}
      </div>
    )
  }
}

export default Seat
